var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9996 9.58887C18.5199 9.58887 9.21387 18.8949 9.21387 30.3746C9.21387 41.8542 18.5199 51.1603 29.9996 51.1603C41.4792 51.1603 50.7853 41.8542 50.7853 30.3746C50.7853 18.8949 41.4792 9.58887 29.9996 9.58887ZM6.21387 30.3746C6.21387 17.2381 16.8631 6.58887 29.9996 6.58887C43.1361 6.58887 53.7853 17.2381 53.7853 30.3746C53.7853 43.5111 43.1361 54.1603 29.9996 54.1603C16.8631 54.1603 6.21387 43.5111 6.21387 30.3746Z",
    fill: "#FF3030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9995 16.875C30.8279 16.875 31.4995 17.5466 31.4995 18.375V28.6607C31.4995 29.4891 30.8279 30.1607 29.9995 30.1607C29.1711 30.1607 28.4995 29.4891 28.4995 28.6607V18.375C28.4995 17.5466 29.1711 16.875 29.9995 16.875Z",
    fill: "#FF3030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.999 38.7305C29.8806 38.7305 29.7847 38.8264 29.7847 38.9448C29.7847 39.0631 29.8806 39.159 29.999 39.159C30.1173 39.159 30.2132 39.0631 30.2132 38.9448C30.2132 38.8264 30.1173 38.7305 29.999 38.7305ZM26.7847 38.9448C26.7847 37.1696 28.2238 35.7305 29.999 35.7305C31.7742 35.7305 33.2132 37.1696 33.2132 38.9448C33.2132 40.72 31.7742 42.159 29.999 42.159C28.2238 42.159 26.7847 40.72 26.7847 38.9448Z",
    fill: "#FF3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed-icon.c026b4e88dca1d4a96ed4b756923e130.svg";
export { ForwardRef as ReactComponent };